import { transformField } from './fieldTransformer';
import { extractPhotos, groupFieldsBySection } from './sectionGrouper';

export const transformFormData = (data) => {
  const { FormStructure, Features, Conversions, CustomFields } = data;

  if (!FormStructure || !FormStructure.Fields) {
    throw new Error('Invalid data structure: FormStructure.Fields is required');
  }

  const fields = FormStructure.Fields
    .map((field) => transformField(field, Features || [], CustomFields || [], Conversions || []))
    .filter(Boolean);

  const photos = extractPhotos(FormStructure.Fields);
  const fieldsBySection = groupFieldsBySection(fields);

  return {
    title: 'Application Form',
    description: 'Please fill in all required fields',
    fields,
    photos,
    fieldsBySection,
    _raw: {
      features: Features,
      conversions: Conversions,
      customFields: CustomFields,
    },
  };
};

export default transformFormData;
